export default __webpack_public_path__ + "static/media/Bonuses@32.0d89ad5f.svg";